import { Box, Typography } from "@mui/material";
import { ReactElement } from "react";
import { Recipe, imageIdToUrlFallback } from "../data";
import "./TiledRecipeBackground.css";

const imageType = "medium" as const;

export default function TiledRecipeBackground({ recipes }: { recipes: Recipe[] }) {
    let inner: ReactElement | ReactElement[] | undefined;
    let gridTemplate: string | undefined;
    if (recipes.length === 1) {
        inner = <img key="img1" className="tiled-bg-img" src={imageIdToUrlFallback(imageType, recipes[0].image_id)} />;
    } else if (recipes.length === 2) {
        gridTemplate = `1fr / 1fr 1fr`;
        inner = [
            <img key="img1" className="tiled-bg-img" src={imageIdToUrlFallback(imageType, recipes[0].image_id)} />,
            <img key="img2" className="tiled-bg-img" src={imageIdToUrlFallback(imageType, recipes[1].image_id)} />,
        ];
    } else if (recipes.length === 3) {
        gridTemplate = `'first second' 1fr 'first third' 1fr / 1fr 1fr`;
        inner = [
            <img
                key="img1"
                className="tiled-bg-img"
                src={imageIdToUrlFallback(imageType, recipes[0].image_id)}
                style={{ gridArea: "first" }}
            ></img>,
            <img
                key="img2"
                className="tiled-bg-img"
                src={imageIdToUrlFallback(imageType, recipes[1].image_id)}
                style={{ gridArea: "second" }}
            ></img>,
            <img
                key="img3"
                className="tiled-bg-img"
                src={imageIdToUrlFallback(imageType, recipes[2].image_id)}
                style={{ gridArea: "third" }}
            ></img>,
        ];
    } else if (recipes.length >= 4) {
        gridTemplate = `'first second' 1fr 'third fourth' 1fr / 1fr 1fr`;
        inner = [
            <img key="img1" className="tiled-bg-img" src={imageIdToUrlFallback(imageType, recipes[0].image_id)} />,
            <img key="img2" className="tiled-bg-img" src={imageIdToUrlFallback(imageType, recipes[1].image_id)} />,
            <img key="img3" className="tiled-bg-img" src={imageIdToUrlFallback(imageType, recipes[2].image_id)} />,
            <img
                key="img4"
                className="tiled-bg-img"
                src={imageIdToUrlFallback(imageType, recipes[3].image_id)}
                style={{ gridArea: "fourth" }}
            />,
        ];

        if (recipes.length > 4) {
            inner.push(
                <Typography
                    key="extra"
                    variant="h5"
                    color="rgb(238, 238, 238)"
                    sx={{
                        gridArea: "fourth",
                        alignContent: "center",
                        textAlign: "center",
                        bgcolor: "rgba(56, 56, 56, 0.75)",
                        userSelect: "none",
                    }}
                >
                    +{recipes.length - 3}
                </Typography>
            );
        }
    }

    return (
        <Box
            sx={{
                position: "absolute",
                width: "100%",
                height: "100%",
                overflow: "hidden",
                display: "grid",
                gap: "2px",
                gridTemplate: gridTemplate,
                margin: "auto",
                bgcolor: "white",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
            }}
        >
            {inner}
        </Box>
    );
}
